import React, { useEffect, useState } from "react";
import Table from "../components/Table";
import { useSelector, useDispatch } from "react-redux";
import HomeBanner from "../components/HomeBanner";
import SIPBoard from "../components/SIPBoard";
import PersonalLoanCalc from "../calculater/PersonalLoanCalc";
import RdCalc from "../calculater/RdCalc";
import FdCalc from "../calculater/FdCalc";
import EducationCalc from "../calculater/EducationCalc";
import CreditCalc from "../calculater/CreditCalc";
import BussinessCalc from "../calculater/BussinessCalc";
import EarlyLoanCalc from "../calculater/EarlyLoanCalc";
import DtiCalc from "../calculater/DtiCalc";
import NetWorthCalc from "../calculater/NetWorthCalc";
import Gstboard from "../calculater/Gstboard";
import SalaryCalc from "../calculater/SalaryCalc";
import PensionCalc from "../calculater/PensionCalc";
import LtvCalc from "../calculater/LtvCalc";
import SavingCalc from "../calculater/SavingCalc";
import CarCalc from "../calculater/CarCalc";
import ContributionCalc from "../calculater/ContributionCalc";
import MortgageCalc from "../calculater/MortgageCalc";
import useLocale from "../locales";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";

const LandingPage = ({}) => {
  const { calculatorType } = useParams();
  const [showTable, setShowTable] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reduxCalculator = useSelector(
    (state) => state.calculator?.activeCalculator
  );

  // Mapping between URL paths and calculator IDs
  const pathToCalculatorMap = {
    "sip-investment-calculator": "sipCalc",
    "personal-loan-calculator": "personalLoanCalc",
    "fixed-deposit-calculator": "FDCalc",
    "recurring-deposit-calculator": "RDCalc",
    "debt-to-income-ratio-calculator": "DTICalc",
    "net-worth-calculator": "netWorthCalc",
    "loan-payoff-calculator": "earlyLoanCalc",
    "student-education-loan-calculator": "educationLoanCalc",
    "credit-card-payoff-calculator": "creditCardPayoffCalc",
    "business-loan-calculator": "businessLoanCalc",
    "gst-tax-calculator": "GSTCalc",
    "salary-calculator": "salaryCalc",
    "pension-calculator": "pensionCalc",
    "car-lease-calculator": "carCalc",
    "mortgage-loan-refinance-calculator": "mortgageCalc",
    "401k-retirement-calculator": "contributionCalc",
    "saving-goal-calculator": "savingCalc",
    "loan-to-value-calculator": "loanToValueCalc",
  };

  const valuePaths = {
    sipCalc: "sip-investment-calculator",
    personalLoanCalc: "personal-loan-calculator",
    FDCalc: "fixed-deposit-calculator",
    RDCalc: "recurring-deposit-calculator",
    DTICalc: "debt-to-income-ratio-calculator",
    netWorthCalc: "net-worth-calculator",
    earlyLoanCalc: "loan-payoff-calculator",
    educationLoanCalc: "student-education-loan-calculator",
    creditCardPayoffCalc: "credit-card-payoff-calculator",
    businessLoanCalc: "business-loan-calculator",
    GSTCalc: "gst-tax-calculator",
    salaryCalc: "salary-calculator",
    pensionCalc: "pension-calculator",
    carCalc: "car-lease-calculator",
    mortgageCalc: "mortgage-loan-refinance-calculator",
    contributionCalc: "401k-retirement-calculator",
    savingCalc: "saving-goal-calculator",
    loanToValueCalc: "loan-to-value-calculator",
  };

  const valuePath = valuePaths[calculatorType];

  const calculatorId = pathToCalculatorMap[calculatorType];
  // Determine active calculator - URL param takes precedence over Redux state
  const activeCalculator = calculatorId || reduxCalculator;

  useEffect(() => {
    if (calculatorId) {
      dispatch({
        type: "SET_ACTIVE_CALCULATOR",
        payload: calculatorId,
      });
    } else if (!calculatorId && valuePath) {
      navigate(`/calculator/${valuePath}`);
    } else {
      navigate("/");
      return;
    }
  }, [calculatorId, dispatch]);

  const setActiveCalculator = (calcName) => {
    // Your implementation here
  };

  const Calculator = () => {
    if (
      !activeCalculator ||
      activeCalculator === "sipCalc" ||
      activeCalculator === "lumpsumCalc"
    ) {
      return (
        <SIPBoard
          showTable={showTable}
          setShowTable={setShowTable}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      );
    }

    if (
      !activeCalculator ||
      activeCalculator === "GSTCalc" ||
      activeCalculator === "VatCalc"
    ) {
      return (
        <Gstboard
          showTable={showTable}
          setShowTable={setShowTable}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      );
    }

    if (calculatorId === "personalLoanCalc") {
      return <PersonalLoanCalc />;
    }

    if (calculatorId === "FDCalc") {
      return <FdCalc setShowTable={setShowTable} />;
    }
    if (calculatorId === "contributionCalc") {
      return <ContributionCalc />;
    }
    if (calculatorId === "RDCalc") {
      return <RdCalc />;
    }

    if (calculatorId === "educationLoanCalc") {
      return <EducationCalc />;
    }

    if (calculatorId === "creditCardPayoffCalc") {
      return <CreditCalc />;
    }
    if (calculatorId === "businessLoanCalc") {
      return <BussinessCalc />;
    }
    if (calculatorId === "earlyLoanCalc") {
      return <EarlyLoanCalc />;
    }
    if (calculatorId === "DTICalc") {
      return <DtiCalc />;
    }
    if (calculatorId === "netWorthCalc") {
      return <NetWorthCalc />;
    }
    // if (activeCalculator === 'GSTCalc') {
    //   return <Gstboard initialActiveTab={0} setActiveCalculator={setActiveCalculator} />;
    // }
    // if (activeCalculator === 'GSTCalc') {
    //   return <Gstboard initialActiveTab={1} setActiveCalculator={setActiveCalculator} />;
    // }
    if (calculatorId === "salaryCalc") {
      return <SalaryCalc />;
    }
    if (calculatorId === "pensionCalc") {
      return <PensionCalc />;
    }
    if (calculatorId === "loanToValueCalc") {
      return <LtvCalc />;
    }
    if (calculatorId === "savingCalc") {
      return <SavingCalc />;
    }
    if (calculatorId === "mortgageCalc") {
      return <MortgageCalc />;
    }

    if (calculatorId === "carCalc") {
      return <CarCalc />;
    }

    // return (
    //   <SIPBoard
    //     showTable={showTable}
    //     setShowTable={setShowTable}
    //     activeTab={activeTab}
    //     setActiveTab={setActiveTab}
    //   />
    // );
  };

  return (
    <>
      <Header />
      {calculatorId && <Calculator />}
      <div className="mt-[10px]">
        {showTable && (!activeCalculator || activeCalculator === "sipCalc") && (
          <Table activeTab={activeTab} />
        )}
      </div>
    </>
  );
};

export default LandingPage;
